<template>
  <v-expansion-panels 
    multiple 
    v-model="keepOpen" 
    flat
    class="mb-2 border">
    <v-expansion-panel>
      <v-expansion-panel-header 
        ripple 
        expand-icon="mdi-chevron-down"
        class="text-h6"
        >
        {{ $t('contract.show.panel_one.title') }}
      </v-expansion-panel-header>
      <v-expansion-panel-content>
        <v-list-item 
          class="px-0"
          two-line>
          <v-list-item-content>
            <v-list-item-subtitle>{{ $t('contract.show.panel_one.items.tenant') }}</v-list-item-subtitle>
            <v-list-item-title>{{contract.tenant[0].profile.name}}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item
          class="px-0"
          two-line>
          <v-list-item-content>
            <v-list-item-subtitle>{{ $t('contract.show.panel_one.items.owners') }}</v-list-item-subtitle>
            <v-list-item-title>{{contract.owner.map( o => o.profile.name).join(', ') }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <div
          class="d-flex flex-row"
          >
          <v-list-item 
            class="px-0"
            two-line>
            <v-list-item-content>
              <v-list-item-subtitle>{{ $t('contract.show.panel_one.items.term') }}</v-list-item-subtitle>
              <v-list-item-title>{{ contract.duration == 1 ? $t('contract.show.panel_one.items.months.one') : $t('contract.show.panel_one.items.months.n', { n: contract.duration }) }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>

          <v-list-item
            class="px-0"
            two-line>
            <v-list-item-content>
              <v-list-item-subtitle>{{ $t('contract.show.panel_one.items.keys') }}</v-list-item-subtitle>
              <v-list-item-title>{{ contract.keys }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </div>

        <div
          class="d-flex flex-row"
          >
          <v-list-item 
            class="px-0"
            two-line>
            <v-list-item-content>
              <v-list-item-subtitle>{{ $t('contract.show.panel_one.items.from') }}</v-list-item-subtitle>
              <v-list-item-title>{{ contract.startsAt }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>

          <v-list-item 
            class="px-0"
            two-line>
            <v-list-item-content>
              <v-list-item-subtitle>{{ $t('contract.show.panel_one.items.to') }}</v-list-item-subtitle>
              <v-list-item-title>{{ contract.endsAt }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </div>

        <div
          class="d-flex flex-row"
          >
          <v-list-item 
            class="px-0"
            :key="i"
            v-for="(price, i) in contract.rent.prices"
            two-line>
            <v-list-item-content>
              <v-list-item-subtitle>{{ $t('contract.show.panel_one.items.period', { n: parseInt(i) + 1 }) }}</v-list-item-subtitle>
              <v-list-item-title>${{price.amount}}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </div>

        <v-list-item 
          class="px-0"
          two-line>
          <v-list-item-content>
            <v-list-item-subtitle>{{ $t('contract.show.panel_one.items.total_contract_price') }}</v-list-item-subtitle>
            <v-list-item-title>${{contract.totalRentPrice}}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <div
          class="d-flex flex-wrap"
          >
          <v-list-item 
            class="px-0"
            :key="tax.id"
            v-for="tax in contract.paymentPlan.taxes.filter( t => t.name != 'Alquiler')"
            two-line>
            <v-list-item-content>
              <v-list-item-subtitle>{{ tax.name }}</v-list-item-subtitle>
              <v-list-item-title>${{ tax.prices[0].amount }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </div>
      </v-expansion-panel-content>
    </v-expansion-panel>
  </v-expansion-panels>
</template>

<script>
export default {
  name:"PanelOne",
  data(){
    return{
      keepOpen: [0],
    }
  },
  props: ['contract']
}
</script>
